// Centralized runtime configuration. Read once on module load.
// In dev the API is reachable via the Vite proxy at /api, so the base
// stays empty. Override at build time via VITE_API_BASE_URL when the
// SPA is deployed on a different origin than the API.
export const env = Object.freeze({
  apiBase: import.meta.env.VITE_API_BASE_URL || '/api/v1',
  appName: import.meta.env.VITE_APP_NAME || 'Orme Palermo',
  isDev: import.meta.env.DEV
});
